import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export function LoadQuoteModal({ open, onOpenChange, quoteId, onQuoteIdChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-[#6A7359]">Load Saved Quote</DialogTitle>
          <DialogDescription>Enter your quote ID to load a previous quote.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-3">
          <Input 
            placeholder="Quote ID (e.g., ABC12345)" 
            value={quoteId} 
            onChange={(e) => onQuoteIdChange(e.target.value.toUpperCase())} 
            data-testid="load-quote-id" 
          />
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">
              Cancel
            </Button>
            <Button 
              onClick={onSubmit} 
              className="flex-1 bg-[#6A7359] hover:bg-[#565E48]" 
              data-testid="load-quote-submit-btn"
            >
              Load Quote
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
